import { PendingUserWithPolicy, UserWithPolicy } from "@xapp/stentor-api-client/dist/api/orgs/orgId/users/Users";

import { removeDuplicates } from "utils/Utils";
import { AddUserToOrganizationEndAction } from "../actions/AddUserToOrganization";
import { FetchUsersOfOrganizationEndAction } from "../actions/FetchUsersOfOrganization";
import { OrgState } from "../state";

function getUserKey(ua: Pick<UserWithPolicy, "email">) {
    return ua.email;
}

function compareUsers(ua: Pick<UserWithPolicy, "email">, ub: Pick<UserWithPolicy, "email">) {
    return ua.email.localeCompare(ub.email);
}

export function addUserToOrganization(
    state: OrgState,
    action: FetchUsersOfOrganizationEndAction | AddUserToOrganizationEndAction
) {
    const { error, result, organizationId } = action.payload;
    const newState: Partial<OrgState> = { error };

    if (result) {
        const { result } = action.payload;
        const users = result.users as UserWithPolicy[];
        const pendingUsers = result.pendingUsers as PendingUserWithPolicy[];

        const existingUsers = state.users[organizationId] || [];
        const existingPendingUsers = state.pendingUsers[organizationId] || [];
        const newUsers = existingUsers.concat(users).sort(compareUsers);
        const newPending = existingPendingUsers.concat(pendingUsers).sort(compareUsers);

        newState.users = { ...state.users };
        newState.pendingUsers = { ...state.pendingUsers };
        newState.users[organizationId] = removeDuplicates<UserWithPolicy>(getUserKey, newUsers);
        newState.pendingUsers[organizationId] = removeDuplicates<PendingUserWithPolicy>(getUserKey, newPending);
    }
    return { ...state, ...newState };
}
